import React from 'react'; //add use state
import { motion } from 'framer-motion';
import { ArrowLeft, Mail, Instagram, Phone, MapPin, Heart } from 'lucide-react'; //add send
import { Link } from 'react-router-dom';

const Contact: React.FC = () => {
  // const [formData, setFormData] = useState({
  //   name: '',
  //   email: '',
  //   message: ''
  // });

  // const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
  //   const { name, value } = e.target;
  //   setFormData(prev => ({
  //     ...prev,
  //     [name]: value
  //   }));
  // };

  // const handleSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   // Handle form submission here
  //   console.log('Form submitted:', formData);
  //   // Reset form
  //   setFormData({ name: '', email: '', message: '' });
  // };

  const contactInfo = [
    {
      icon: Mail,
      title: 'Email',
      value: 'reshmi@handandheart.com',
      link: 'mailto:reshmi@handandheart.com'
    },
    {
      icon: Instagram,
      title: 'Instagram',
      value: '@handandheart_art',
      link: 'https://instagram.com/handandheart_art'
    },
    {
      icon: Phone,
      title: 'Phone',
      value: '+1 (555) 123-4567',
      link: 'tel:+15551234567'
    },
    {
      icon: MapPin,
      title: 'Location',
      value: 'Art Studio, Creative District',
      link: '#'
    }
  ];

  return (
    <div className="min-h-screen bg-cream-50">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-sm border-b border-cream-200">
        <div className="flex items-center px-4 py-4">
          <Link
            to="/"
            className="flex items-center space-x-2 text-warm-700 hover:text-warm-900 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="font-medium">Back to Home</span>
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <div className="pt-20">
        <div className="max-w-4xl mx-auto section-padding">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center mb-12"
          >
            <h1 className="text-4xl sm:text-5xl font-serif font-bold text-warm-800 mb-4">
              Let's Connect
            </h1>
            <p className="text-lg sm:text-xl text-warm-600 max-w-2xl mx-auto">
              I'd love to hear from you! Whether you're interested in my artwork, 
              want to discuss a custom piece, or just want to say hello.
            </p>
          </motion.div>

          <div className="grid lg:grid-cols-2 gap-12">
            {/* Contact Form */}
            {/* <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="card"
            >
              <h2 className="text-2xl font-serif font-semibold text-warm-800 mb-6">
                Send a Message
              </h2>
              
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-warm-700 mb-2">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-cream-300 rounded-lg focus:ring-2 focus:ring-warm-500 focus:border-transparent transition-colors bg-white"
                    placeholder="Your name"
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-warm-700 mb-2">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    className="w-full px-4 py-3 border border-cream-300 rounded-lg focus:ring-2 focus:ring-warm-500 focus:border-transparent transition-colors bg-white"
                    placeholder="your.email@example.com"
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-warm-700 mb-2">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows={5}
                    className="w-full px-4 py-3 border border-cream-300 rounded-lg focus:ring-2 focus:ring-warm-500 focus:border-transparent transition-colors bg-white resize-none"
                    placeholder="Tell me about your project or just say hello..."
                  />
                </div>

                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  type="submit"
                  className="w-full btn-primary inline-flex items-center justify-center space-x-2"
                >
                  <Send className="w-5 h-5" />
                  <span>Send Message</span>
                </motion.button>
              </form>
            </motion.div> */}

            {/* Contact Information */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              className="space-y-8"
            >
              <div>
                <h2 className="text-2xl font-serif font-semibold text-warm-800 mb-6">
                  Get in Touch
                </h2>
                <p className="text-warm-600 mb-8">
                  Feel free to reach out through any of these channels. I typically respond within 24 hours.
                </p>
              </div>

              <div className="space-y-6">
                {contactInfo.map((info, index) => (
                  <motion.a
                    key={info.title}
                    href={info.link}
                    target={info.title === 'Instagram' ? '_blank' : undefined}
                    rel={info.title === 'Instagram' ? 'noopener noreferrer' : undefined}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.6 + index * 0.1 }}
                    className="flex items-center space-x-4 p-4 rounded-lg hover:bg-cream-100 transition-colors group"
                  >
                    <div className="flex-shrink-0 w-12 h-12 bg-warm-100 rounded-lg flex items-center justify-center group-hover:bg-warm-200 transition-colors">
                      <info.icon className="w-6 h-6 text-warm-600" />
                    </div>
                    <div>
                      <h3 className="font-medium text-warm-800">{info.title}</h3>
                      <p className="text-warm-600">{info.value}</p>
                    </div>
                  </motion.a>
                ))}
              </div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 1 }}
                className="bg-gradient-to-br from-cream-200 to-cream-300 rounded-xl p-6"
              >
                <h3 className="font-semibold text-warm-800 mb-3">Studio Hours</h3>
                <div className="space-y-2 text-warm-700">
                  <p>Monday - Friday: 10:00 AM - 6:00 PM</p>
                  <p>Saturday: 11:00 AM - 4:00 PM</p>
                  <p>Sunday: By appointment only</p>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-warm-800 text-white py-8 mt-20">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="flex items-center justify-center space-x-2 mb-4"
          >
            <Heart className="w-5 h-5 text-red-400" />
            <span className="text-lg font-medium">Hand&Heart</span>
          </motion.div>
          <p className="text-cream-200">
            © 2025 Reshmi. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Contact; 